export const DS_CONTAINERBOX = 'DS-containerbox';
export const DS_CONTAINERDISABLED = 'DS-containerDisabled';
export const DS_FULLSIZE = 'DS-fulSize';
export const DS_FULLWIDTH = 'DS-fullWidth';
export const DS_FULLHEIGHT = 'DS-fullHeight';
export const DS_BG_RED = 'DS-bgRed';
export const DS_BG_BLUE = 'DS-bgBlue';
export const DS_BG_GREEN = 'DS-bgGreen';
export const DS_BG_YELLOW = 'DS-bgYellow';
export const DS_TAREO_REPORTE_CELL = 'DS-TareoReporteCell';
